import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=e3c6add6&scoped=true&lang=pug&"
import script from "./AlertBox.vue?vue&type=script&lang=js&"
export * from "./AlertBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=e3c6add6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c6add6",
  null
  
)

export default component.exports